import "./Header.css";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const Header = ({ title }) => {
  const navigate = useNavigate();

  return (
    <div className="header-container">
      <ArrowLeftOutlined
        onClick={() => navigate(-1)}
        className="back-arrow-icon"
      />
      <p className="header-title">{title}</p>
    </div>
  );
};

export default Header;
